"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiKey = void 0;
const getApiKey = () => {
    const FABRIC_MAPBOX_KEY = window["RUNTIME_ENV_VARS"] && window["RUNTIME_ENV_VARS"]["MAPBOX_KEY"];
    const API_KEY = FABRIC_MAPBOX_KEY ||
        process.env.REACT_APP_FABRIC_MAPBOX_API_KEY ||
        "REACT_APP_FABRIC_MAPBOX_API_KEY";
    return API_KEY;
};
exports.getApiKey = getApiKey;
